import ReactDOM from 'react-dom/client';
import React from 'react';
import { TenantContext } from '../../context/tenant-context';
import { v2Component } from '../../index';
import { SocialLogin } from './social-login';
import './social-login.scss';
export function initSocialLoginComponent() {
  document.body.addEventListener('oauth-form-loaded', showOauth);

  function showOauth() {
    document.getElementsByName('social-login-component').forEach((element) => {
      if (element.getAttribute('initialized') !== 'true') {
        element.setAttribute('initialized', 'true');
        const root = ReactDOM.createRoot(element);
        const { tenant, contextPath, redirect, ...props } = Object.assign({}, element.dataset) as any;
        root.render(
          v2Component(
            <TenantContext.Provider value={{ tenant, contextPath, spaMode: false }}>
              <SocialLogin redirect={redirect} {...props} />
            </TenantContext.Provider>,
          ),
        );

        const event = new CustomEvent('change');
        element.dispatchEvent(event);
      }
    });
  }

  showOauth();
}
